import { useCallback } from "react";
import { httpsCallable } from "firebase/functions";
import { functions, auth } from "@/config/firebase";
export function useApi() {
    const callApi = useCallback(async (type, data) => {
        const currentUser = auth.currentUser;
        if (!currentUser) {
            throw new Error("Not authenticated");
        }
        const token = await currentUser.getIdToken();
        const callable = httpsCallable(functions, "apiV1");
        const result = await callable({ type, data, token });
        const response = result.data;
        if (!response.success) {
            throw new Error(response.error.message);
        }
        return response.data;
    }, []);
    return { callApi };
}
